document.addEventListener('DOMContentLoaded',()=>{
  const videos=[...document.querySelectorAll('.fg-real-loop')];
  if(!videos.length)return;
  const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
  const inView=new WeakMap();
  const update=video=>{
    if(motion.matches||document.hidden||!inView.get(video)){video.pause();return;}
    video.muted=true;
    video.play().catch(()=>{});
  };
  const observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
    inView.set(entry.target,entry.isIntersecting);
    update(entry.target);
  }),{threshold:.15});
  videos.forEach(video=>{video.pause();observer.observe(video);});
  motion.addEventListener('change',()=>videos.forEach(update));
  document.addEventListener('visibilitychange',()=>videos.forEach(update));
});
